import { act, renderHook, waitFor } from "@testing-library/react";
import { useCreateRowMutation } from "../../hooks/useViewDataQuery";
import type { ProcessedViewData } from "../../services/viewService";
import { useRowOperations } from "./useRowOperations";

jest.mock("../../hooks/useViewDataQuery", () => ({
  useCreateRowMutation: jest.fn(),
}));

const mockUseCreateRowMutation = useCreateRowMutation as jest.Mock;
const data = {
  columns: [{ field: "name", editMode: "DIRECT" }],
  rows: [],
} as unknown as ProcessedViewData;

describe("useRowOperations", () => {
  it("uses the runtime create callback for inline saves", async () => {
    const defaultCreate = jest.fn();
    const runtimeCreate = jest.fn().mockResolvedValue(undefined);
    mockUseCreateRowMutation.mockReturnValue({
      mutateAsync: defaultCreate,
      isPending: false,
    });
    const { result } = renderHook(() =>
      useRowOperations({ viewId: "view-1", data, onCreateRow: runtimeCreate }),
    );

    await act(async () => {
      await result.current.handleSaveNewRow({
        _rowId: "__new_row__",
        name: "Visible",
      });
    });

    await waitFor(() =>
      expect(runtimeCreate).toHaveBeenCalledWith({ name: "Visible" }),
    );
    expect(defaultCreate).not.toHaveBeenCalled();
  });
});
